module.exports = __webpack_public_path__ + "media/components/country-flag/static/ph-64c3d8b03bf21d10661c2384ebf3247f.svg";